import { useCallback, useEffect, useMemo, useState } from 'react';
import { IConfigEntityLinks, SDKOptions, SportTypes } from '../types';
import { IStandingsStageResponse } from '../types/standings';
import normalizePlayoffKnockoutData from '../normalizers/src/multi-sport/normalizePlayoffKnockoutResponseData';
import { INormalizedMultisportPlayoffData } from '../types/multisport-playoff';
import { getPlayoffs } from '../services/multi-sport/playoffs';
interface IUsePlayoffArgs {
  availableStages?: IStandingsStageResponse[];
  stageId?: string;
  sport: SportTypes;
  sdkOptions: SDKOptions;
  dataEntityLinks?: IConfigEntityLinks;
}

export default function usePlayoff({ availableStages, stageId, sport, sdkOptions, dataEntityLinks }: IUsePlayoffArgs) {
  const [playoffStage, setPlayoffStage] = useState<INormalizedMultisportPlayoffData | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPlayoffStageSelected, setIsPlayoffStageSelected] = useState<boolean>(false);

  const playoffStagesId = useMemo(
    () => availableStages?.filter((stage) => stage?.available_playoffs).map((stage) => stage.id),
    [availableStages],
  );

  const fetchPlayoffs = useCallback(
    (manageLoader: boolean) => {
      if (stageId && playoffStagesId && playoffStagesId.includes(stageId)) {
        setIsPlayoffStageSelected(true);
        const params = { stage_id: stageId };
        manageLoader && setIsLoading(true);
        getPlayoffs({ params, sdkOptions, sport })
          .then((response) => {
            const normalizedPlayoffData = normalizePlayoffKnockoutData(response, dataEntityLinks);
            manageLoader && setIsLoading(false);
            setPlayoffStage(normalizedPlayoffData);
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      } else {
        setIsPlayoffStageSelected(false);
        setPlayoffStage(null);
      }
    },
    [stageId, playoffStagesId, dataEntityLinks, sdkOptions, sport],
  );

  useEffect(() => {
    fetchPlayoffs(true);
  }, [fetchPlayoffs, stageId, playoffStagesId]);

  return {
    playoffStage,
    isPlayoffStageSelected,
    showWidget: true,
    isLoading,
  };
}
